import phonenumbersData from "./phoneNumbers.json";
import { PhoneNumbers } from "./phoneNumbers.type";

const phoneNumbers: PhoneNumbers = phonenumbersData;

// there were duplicates
const brandRedirectMap: {
  [key: string]: string;
} = {
  dinersclub: "diners",
  sas: "saseurobonusmc",
  sebcorplimit: "sebcorp",
};
const brands: {
  [key: string]: string;
} = {
  // Soon to be dead Cobrands
  diners: "Diners Club",

  // MiniCobrands
  corpmastercard: "DNB Corporate Mastercard",
  op: "OP Corporate Gold",
  circlek: "Circle K",
  dnb: "DNB",
  finnair: "Finnair Plus",
  ingo: "Ingo",
  jyske: "Jyske",
  landkreditt: "Landkreditt",
  nknyckeln: "NK Nykeln",
  // 'nordicchoiceclubms': 'Nordic Choice',
  nordicchoiceclubms: "Strawberry",
  strawberry: "Strawberry",
  opelkortet: "Opel",
  saabkortet: "Saab",
  sjprio: "SJ Prio",
  volvo: "Volvo",
  scandicfriends: "Scandic Friends",

  // Cobrands
  esso: "Esso",
  globecard: "Globe Card",
  saseurobonusmc: "SAS Eurobonus",

  // Own brands
  eurocard: "Eurocard",
  eurocardinternational: "Eurocard",
  airplus: "Airplus",
  spendwise: "Spendwise",

  // SEB
  seb: "SEB",
  sebcorp: "SEB",
  sebcorplimit: "SEB",
  sebdebit: "SEB",
  sebcredit: "SEB",
  sebselected: "SEB Selected",

  sebkort: "SEB Kort",
};
function getBrandName(key: string): string {
  if (typeof brands[key] === "string") {
    return brands[key];
  }
  return key;
}
function isKnownBrand(brand: string) {
  return Object.hasOwn(brands, brand);
}
export type phones = {
  [key: string]: {
    label: string;
    value: string;
  };
};
function hasSupportPhoneNumbers({
  brand,
  lang,
}: {
  brand: string;
  lang: string;
}): boolean {
  return !!Object.keys(getPhoneNumbers({ brand, lang })).length;
}
function getInvalidBrandQueryString(
  brand: string | string[] | undefined,
  locale: string,
): string {
  const currBrand = Array.isArray(brand) ? brand[0] : brand?.trim();
  if (!currBrand?.length) {
    return "Missing brand";
  }
  if (!isKnownBrand(currBrand)) {
    return `Unknown brand, please use one of the following brands: ${Object.keys(
      brands,
    ).join(", ")}`;
  }
  if (!hasSupportPhoneNumbers({ brand: currBrand, lang: locale })) {
    return "Missing Support Phone numbers for this brand!";
  }
  return "";
}
function getCountryPhonePrefix({
  brand,
  lang,
}: {
  brand: string;
  lang: string;
}) {
  let countryPrefix = "";
  if (phoneNumbers.phoneCountryCodes[lang] !== undefined) {
    countryPrefix = phoneNumbers.phoneCountryCodes[lang];
  }
  return countryPrefix;
}
function getPhoneNumbers({
  brand: origBrand,
  lang,
}: {
  brand: string;
  lang: string;
}): phones {
  const brand = brandRedirectMap[origBrand] ?? origBrand;

  if (phoneNumbers.brands[brand] === undefined) {
    return {};
  }
  if (phoneNumbers.brands[brand][lang] === undefined) {
    if (phoneNumbers.brands[brand]["default"] === undefined) {
      let result: phones = {};
      let c = 0;
      Object.keys(phoneNumbers.brands[brand]).forEach((key) => {
        Object.keys(phoneNumbers.brands[brand][key]["phone"]).forEach(
          (key2) => {
            result[`${c}`] = phoneNumbers.brands[brand][key]["phone"][key2];
            c++;
          },
        );
      });
      return result;
    } else {
      return phoneNumbers.brands[brand]["default"]["phone"];
    }
  }
  return phoneNumbers.brands[brand][lang]["phone"];
}

const getBlockCardNumber = (
  country: string | string[] | undefined,
  locale: string,
) => {
  const germanyFranceNumber = "+46 8 14 68 28";
  const numbers: { [key: string]: string } = {
    sv: "+46 774 24 24 24",
    da: "+45 70 301 201",
    no: "+47 21 01 50 40",
    fi: "+358 800 155 777",
    en: "+45 36 73 72 05", // CBI
    de: germanyFranceNumber,
    fr: germanyFranceNumber,
  };
  numbers.dk = numbers.da;
  numbers.se = numbers.sv;
  const strCountry = Array.isArray(country) ? country[0] : country;
  if (strCountry) {
    if (numbers[strCountry]) {
      return numbers[strCountry];
    }
  }
  if (numbers[locale]) {
    return numbers[locale];
  }
  return "Unknown";
};

export {
  brandRedirectMap,
  getBlockCardNumber,
  getBrandName,
  getCountryPhonePrefix,
  getInvalidBrandQueryString,
  getPhoneNumbers,
  hasSupportPhoneNumbers,
  isKnownBrand,
};
